import React, { Component } from 'react';
import PropTypes from 'prop-types';
import connect from './connect';
import { Link } from 'react-router';
import PageTable from './page-table';
import MenuSettings from './menu-settings';
import PageProducer from './page-producer';
import SectionTable from './section-table';
import SectionProducer from './section-producer';
import PageTemplateTable from './page-template-table';
import PageTemplateProducer from './page-template-producer';
import SectionTemplateTable from './section-template-table';
import SectionTemplateProducer from './section-template-producer';
import { Col, Panel, Alert, Row, Button, Well } from 'react-bootstrap';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selecting_template_type: false,
      selecting_document_type: false,
    }

    this.toggleSelecting = this.toggleSelecting.bind(this);
  }
  toggleSelecting(type, bool) {
    this.setState({
      [`selecting_${type}`]: typeof bool === 'boolean' ? bool : !this.state[`selecting_${type}`]
    });
  }
  render() {
    const { pathname, page_manager } = this.props;
    const { selecting_document_type, selecting_template_type } = this.state;

    if(pathname.match(/menu-settings/gi)) {
      return (
        <MenuSettings />
      )
    }

    if(pathname.match(/sales-site\/pages\/create/gi)) {
      return (
        <PageProducer key={0} />
      );
    }

    if(pathname.match(/sales-site\/pages\/.*/gi)) {
      const pieces = pathname.split('/')
      return (
        <PageProducer key={1} pageId={pathname.split('/').pop()} />
      )
    }

    if(pathname.match(/sales-site\/sections\/create/gi)) {
      return (
        <SectionProducer />
      );
    }

    if(pathname.match(/sales-site\/section-templates\/create/gi)) {
      return (
        <SectionTemplateProducer />
      );
    }

    if(pathname.match(/sales-site\/page-templates\/create/gi)) {
      return (
        <PageTemplateProducer />
      );
    }

    if(pathname.match(/sales-site\/pages/gi)) {
      return (
        <PageTable />
      );
    }

    if(pathname.match(/sales-site\/sections/gi)) {
      return (
        <SectionTable />
      );
    }

    if(pathname.match(/sales-site\/section-templates/gi)) {
      return (
        <SectionTemplateTable />
      );
    }

    if(pathname.match(/sales-site\/page-templates/gi)) {
      return (
        <PageTemplateTable />
      );
    }

    return (
      <Row>
        <Alert bsStyle='info'>
          <p>Not Implemented.</p>
        </Alert>
      </Row>
    )
  }
}

export default connect(Dashboard);



// WEBPACK FOOTER //
// ./src/browser/components/sales-site-manager/dashboard.js